// libs
import React from 'react';
//dls
import { DlsColorTokens } from '@/constants/DLSTokens';
import { Svg16 as ArrowDown } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronDown';
//widgets
import { Chip } from '@/widgets/Chip';
import Menu from '@/components/Menu';
import DropdownContent from './widgets/DropdownContent';
// styles
import style from './ActionMenu.module.scss';
// stores
import useConfigStore from '@/stores/Configs';
// components
import Tooltip from '@/components/Tooltip';
const ActionMenu = ({ campaignName, campaignId, campaignStatus }) => {
    const { campaignOpDisabled, campaignOpDisabledCallout } = useConfigStore((state) => ({
        campaignOpDisabled: state.campaignOpDisabled,
        campaignOpDisabledCallout: state.campaignOpDisabledCallout,
    }));
    const menuApiRef = React.useRef(null);
    const handleMenuToggle = () => {
        if (menuApiRef.current) {
            menuApiRef.current.isOpen
                ? menuApiRef.current.close()
                : menuApiRef.current.open();
        }
    };
    const renderMenuLabel = () => {
        const chipNode = (React.createElement("div", { className: style.wrapper },
            React.createElement(Chip, { label: "Actions", labelColor: DlsColorTokens.primary, ActionIcon: ArrowDown, showActionButton: true, onChipClick: handleMenuToggle, disabled: campaignOpDisabled })));
        return campaignOpDisabled ? (React.createElement(Tooltip, { content: campaignOpDisabledCallout, inline: false }, chipNode)) : (chipNode);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { Content: DropdownContent, ref: menuApiRef, placement: "bottom-start", offset: 10, contentProps: { campaignName, campaignId, campaignStatus } }, renderMenuLabel())));
};
export default ActionMenu;
